export const constructHyvorSso = () => {
  const sso = {
    'sso-hash': JSON.parse(localStorage.hyvorHash),
    'sso-user': JSON.parse(localStorage.hyvorUserData),
    loginURL: 'https://crowe.org',
  };
  return sso;
};
